import Component from 'flarum/common/Component';
import Link from 'flarum/common/components/Link';
import app from 'flarum/forum/app';

export default class EventCard extends Component {
  view() {
    const event = this.attrs.event;
    const discussion = event.discussion();

    if (!discussion) return null;

    const eventDate = new Date(event.eventDate());
    const eventEndDate = event.eventEndDate() ? new Date(event.eventEndDate()) : null;

    const eventStatus = event.eventStatus() || 'scheduled';

    return (
      <div className={`EventCard ${eventStatus === 'cancelled' ? 'EventCard--cancelled' : ''}`}>
        <Link href={app.route.discussion(discussion)}>
          <div className="EventCard-date">
            <i className="fas fa-calendar"></i>
            {this.formatDate(eventDate)}
            {eventEndDate && (
              <span> → {this.isSameDay(eventDate, eventEndDate) ? this.formatTime(eventEndDate) : this.formatDate(eventEndDate)}</span>
            )}
          </div>
          <div className="EventCard-title">
            {event.isPrivate() && (
              <span className="EventCard-privateBadge" title={app.translator.trans('florcarioca-rsvp.forum.event.private')}>
                <i className="fas fa-lock"></i>
              </span>
            )}
            {eventStatus === 'scheduled' && (
              <span className="EventCard-statusBadge EventCard-statusBadge--scheduled" title={app.translator.trans('florcarioca-rsvp.forum.event.status_scheduled')}>
                <i className="fas fa-clock"></i>
              </span>
            )}
            {eventStatus === 'confirmed' && (
              <span className="EventCard-statusBadge EventCard-statusBadge--confirmed" title={app.translator.trans('florcarioca-rsvp.forum.event.status_confirmed')}>
                <i className="fas fa-check-double"></i>
              </span>
            )}
            {eventStatus === 'cancelled' && (
              <span className="EventCard-statusBadge EventCard-statusBadge--cancelled" title={app.translator.trans('florcarioca-rsvp.forum.event.status_cancelled')}>
                <i className="fas fa-ban"></i>
              </span>
            )}
            {event.title()}
          </div>
          {event.location() && (
            <div className="EventCard-location">
              <i className="fas fa-map-marker-alt"></i> {event.location()}
            </div>
          )}
          <div className="EventCard-stats">
            {app.session.user && (
              <span className={`EventCard-myRsvp EventCard-myRsvp--${event.myStatus() || 'no_response'}`}>
                <i className={this.getMyStatusIcon(event.myStatus())}></i>
                {app.translator.trans('florcarioca-rsvp.forum.events_page.my_status_' + (event.myStatus() || 'no_response'))}
              </span>
            )}
            <span>
              <i className="fas fa-check-circle"></i> {event.attendeeCount()} {app.translator.trans('florcarioca-rsvp.forum.events_page.participants')}
            </span>
            {event.notAttendingCount() > 0 && (
              <span>
                <i className="fas fa-times-circle"></i> {event.notAttendingCount()}
              </span>
            )}
          </div>
        </Link>
      </div>
    );
  }

  formatDate(date) {
    return date.toLocaleDateString('fr-FR', {
      weekday: 'short',
      day: 'numeric',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
    });
  }

  formatTime(date) {
    return date.toLocaleTimeString('fr-FR', {
      hour: '2-digit',
      minute: '2-digit',
    });
  }

  isSameDay(date1, date2) {
    return date1.getFullYear() === date2.getFullYear() &&
           date1.getMonth() === date2.getMonth() &&
           date1.getDate() === date2.getDate();
  }

  getMyStatusIcon(status) {
    const icons = {
      attending: 'fas fa-check-circle',
      not_attending: 'fas fa-times-circle',
    };
    return icons[status] || 'fas fa-question-circle';
  }
}
